<template>
  <vue-aos animation-class="slide-in animated" :threshold="0">
    <section class="contact mt-4 section-padding text-white">
      <div class="text-center mb-5">
        <h1 class="underline letter-spacing-md text-white">Get in Touch</h1>
      </div>
      <div class="container">
        <div class="row align-items-md-end align-items-lg-center">
          <div class="col-12 col-md-6 mb-4 mb-md-0">
            <h3 class="letter-spacing-md mb-4 text-center text-md-left">
              Feel Free To Contact
            </h3>

            <div class="contact__mediums">
              <div class="d-flex flex-wrap justify-content-between">
                <a
                  href="tel:00923070301064"
                  class="contact__mediums__phone contact__mediums__medium d-inline-block bg-portfolio1 text-portfolio4 contact__tags py-2 text-center px-0 px-lg-3 text-lg-left mb-3"
                  target="_blank"
                >
                  <font-awesome-icon :icon="['fas', 'phone']" rotation="90" />
                  <span class="ml-2">+923070301064</span>
                </a>
                <a
                  href="tel:00971567679715"
                  class="contact__mediums__phone contact__mediums__medium d-inline-block bg-portfolio1 text-portfolio4 contact__tags py-2 text-center px-0 px-lg-3 text-lg-left mb-3"
                  target="_blank"
                >
                  <font-awesome-icon :icon="['fas', 'phone']" rotation="90" />
                  <span class="ml-2">+971567679715</span>
                </a>

                <a
                  href="mailto:admin@robustoffice.com"
                  class="contact__mediums__phone contact__mediums__medium d-inline-block bg-portfolio1 text-portfolio4 contact__tags py-2 text-center px-0 px-lg-3 text-lg-left mb-3"
                  target="_blank"
                >
                  <font-awesome-icon :icon="['fas', 'envelope']" />
                  <span class="ml-2">admin@robustoffice.com</span>
                </a>
                <a
                  href="https://www.facebook.com/Robust-Office-Web-Solutions-105687915094829"
                  class="contact__mediums__phone contact__mediums__medium d-inline-block bg-portfolio1 text-portfolio4 contact__tags py-2 text-center px-0 px-lg-3 text-lg-left mb-3"
                  target="_blank"
                >
                  <font-awesome-icon :icon="['fab', 'facebook']" />
                  <span class="ml-2">Facebook</span>
                </a>
                <a
                  href="https://www.instagram.com/robustoffice/"
                  class="contact__mediums__phone contact__mediums__medium d-inline-block bg-portfolio1 text-portfolio4 contact__tags py-2 text-center text-lg-left mb-3 px-0 px-lg-3"
                  target="_blank"
                >
                  <font-awesome-icon :icon="['fab', 'instagram']" />
                  <span class="ml-2">instagram</span>
                </a>
                <a
                  href="https://wa.me/00923070301064?text=Hello, Thank you for contacting us , we will get back to you shortly!"
                  target="_blank"
                  class="contact__mediums__phone contact__mediums__medium d-inline-block bg-portfolio1 text-portfolio4 contact__tags py-2 text-center px-0 px-lg-3 text-lg-left"
                >
                  <font-awesome-icon :icon="['fab', 'whatsapp']" />
                  <span class="ml-2">whatsapp</span>
                </a>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <b-form @submit.prevent="sendMail" class="p-4 contact__form">
              <b-form-group
                v-for="(el, index) in form"
                :key="index"
                class="input-portfolio1-container mb-3"
                :class="{ focused: el.focused }"
              >
                <font-awesome-icon
                  class="position-absolute input-portfolio1-container__icon"
                  :icon="['fas', el.icon]"
                />
                <b-form-input
                  @focus="el.focused = true"
                  @blur="el.focused = false"
                  class="input-portfolio1 pl-4"
                  v-model="el.value"
                  :type="el.type"
                  required
                  :placeholder="el.placeholder"
                ></b-form-input>
              </b-form-group>
              <b-form-textarea
                id="textarea"
                v-model="detail"
                placeholder="Please discuss with us..."
                rows="4"
                max-rows="6"
                class="textarea-portfolio1 mt-4"
              ></b-form-textarea>
              <button
                class="align-items-center d-flex justify-content-center align-items-center btn btn-portfolio1 mt-3 d-block  text-portfolio4 font-weight-bold letter-spacing-md text-uppercase contact-btn"
              >
                <b-spinner
                  v-if="showspinner"
                  small
                  label="Small Spinner mx-1"
                ></b-spinner>
                <p class="text-center my-2 mx-1">Submit</p>
              </button>
            </b-form>
          </div>
        </div>
      </div>
    </section>
  </vue-aos>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      detail: "",

      showspinner: false,
      form: [
        {
          label: "name",
          value: "",
          focused: false,
          type: "text",
          placeholder: "Name",
          icon: "user",
        },
        {
          label: "email",
          value: "",
          focused: false,
          type: "email",
          placeholder: "Email",
          icon: "envelope",
        },
        {
          label: "subject",
          value: "",
          focused: false,
          type: "text",
          placeholder: "Subject",
          icon: "newspaper",
        },
      ],
    };
  },
  methods: {
    makeToast(msg, type) {
      this.$toast.open({
        message: `${msg}`,
        type: type,
        position: "top-right",
      });
    },
    sendMail() {
      this.showspinner = true;
      let name;
      let email;
      let subject;
      this.form.forEach((el) => {
        if (el.label == "name") {
          name = el.value;
        }
        if (el.label == "email") {
          email = el.value;
        }
        if (el.label == "subject") {
          subject = el.value;
        }
      });

      let params = {
        name,
        from: email,
        subject: subject,
        detail: this.detail,
      };
      axios
        .post("https://www.robustoffice.com/mail/send", params)
        .then((res) => {
          if (res.data.accepted.length > 0) {
            this.makeToast("An Email has been sent Successfully.", "success");

            this.showspinner = false;
          }
        })
        .catch((err) => {
          this.showspinner = false;
          this.makeToast(err.message, "danger");
          console.error(err);
        });
    },
  },
};
</script>
